import "@fontsource/clear-sans";
import "./src/components/main.css";
import "normalize.css";

import React from "react";
import { LangProvider } from "./src/contexts/LangContext";
import { CookiesProvider } from "react-cookie";
import AppShell from "./src/components/appshell";

const GA_ID = process.env.GATSBY_GA_MEASUREMENT_ID;

/**
 * ROOT WRAPPERS
 */
export const wrapRootElement = ({ element }) => (
  <CookiesProvider>
    <LangProvider>
      <AppShell>{element}</AppShell>
    </LangProvider>
  </CookiesProvider>
);

/**
 * GA INIT
 */
export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;

  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  // default consent (always denied start)
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
  });

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.gtag("js", new Date());

  window.gtag("config", GA_ID, {
    send_page_view: false,
  });
};

/**
 * SPA PAGEVIEWS (clean + no duplicates)
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;
  if (!window.gtag) return;

  // IMPORTANT: wait for consent state to exist
  const consent = localStorage.getItem("cookie-consent");

  if (consent !== "accepted" && consent !== "denied") return;

  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
};